import { Divider, Typography } from "@mui/material"
import RandomQueueAdder from "./RandomQueueAdder"
import RandomQueueItem from "./RandomQueueItem"
import { useSelector } from "react-redux"
import { getAutoNewRandomAlbum } from "../../reducers/userSettings"
import { isEditingQueue, isRepeatModeOn } from "../../reducers/randomMode"

const NextAlbumsDisplayer = ({nextAlbums, queuePointer}) => {
    const autoNewRandomAlbum = useSelector(getAutoNewRandomAlbum);
    const randomRepeatModeOn = useSelector(isRepeatModeOn);
    const editingMode = useSelector(isEditingQueue);

    const NextAlbumDisplayer = (album, index) => {
        return (
            <div key={queuePointer + index} className="d-flex flex-column jc-center ai-center gap-0_5 full-width">
                <RandomQueueItem
                    album={album}
                    queueIndex={queuePointer + index}
                    canDeleteAlbum={!autoNewRandomAlbum || randomRepeatModeOn || nextAlbums.length > 1}
                />
                { /* If the autoNewRandomAlbum setting is off or if there are at least two next albums, then the album can be deleted */ }  
                <RandomQueueAdder 
                    queueIndex={queuePointer + index + 1} 
                    visible={editingMode}
                />
            </div>
        )
    }

    return (
        <>
            {
                <div className="d-flex flex-column jc-center ai-center gap-0_5 full-width">
                    <div className="full-width d-flex flex-column gap-0_5">
                        <Typography variant="subtitle1">Next albums</Typography>
                        <Divider />
                    </div>
                    <RandomQueueAdder queueIndex={queuePointer} visible={editingMode} />
                    {
                        nextAlbums.map(NextAlbumDisplayer)
                    }
                </div>
            }
        </>
    )
}

export default NextAlbumsDisplayer;